export { default as CustomAvatar } from './CustomAvatar';
